import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class AboutArea extends Component {
  render() {
    const imagePart = (
      <div className='col-lg-6 col-md-8'>
        <div className='pr-0 pr-lg-5'>
          <img className='img-fluid' src={process.env.PUBLIC_URL + '/assets/images/about-image.jpg'} alt='about' loading="lazy" />
        </div>
      </div>
    );

    const descPart = (
      <div className='col-lg-6 col-md-10'>
        <div className={this.props.design === 'home_1' ? 'block text-center mt-5 mt-lg-0' : 'block'}>
          {/* Trust Badge */}
          <div className='mb-20' style={{ display: 'flex', justifyContent: this.props.design === 'home_1' ? 'center' : 'flex-start', gap: '15px', flexWrap: 'wrap' }}>
            <span style={{
              display: 'inline-flex',
              alignItems: 'center',
              background: 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '8px',
              fontSize: '0.85rem',
              fontWeight: '600'
            }}>
              <i className="fas fa-award mr-2" />
              Since 2006
            </span>
            <span style={{
              display: 'inline-flex',
              alignItems: 'center',
              background: 'linear-gradient(135deg, #ffaa19 0%, #e69500 100%)',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '8px',
              fontSize: '0.85rem',
              fontWeight: '600'
            }}>
              <i className="fas fa-tools mr-2" />
              19+ Years Experience
            </span>
          </div>

          <h2 className='h1 text-dark'>
            Delivering top-quality computer and mobile services with 19 years of experience.
          </h2>
          <p className='mt-25'>
            Since 2006, Cell Station has been dedicated to providing top-notch repair services for damaged cell
            phones. From screen replacements and charging ports to batteries, cameras, speakers, back glass, and
            motherboard repairs, we provide the best possible solutions. Our technicians undergo constant training to stay
            proficient in digital device repair while providing a comfortable and friendly experience.
          </p>
          <p className='mt-25'>
            At Cell Station, our team of experts is dedicated to delivering fast and budget-friendly service to the
            community. We're passionate about tech and want to help you make the most of the devices you love.
          </p>

          {/* Stats Row */}
          <div className='mt-30 mb-30' style={{ display: 'flex', justifyContent: this.props.design === 'home_1' ? 'center' : 'flex-start', gap: '30px', flexWrap: 'wrap' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', fontWeight: '700', color: '#007bff' }}>19+</div>
              <div style={{ fontSize: '0.85rem', color: '#6c757d' }}>Years</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', fontWeight: '700', color: '#ffaa19' }}>10K+</div>
              <div style={{ fontSize: '0.85rem', color: '#6c757d' }}>Repairs</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', fontWeight: '700', color: '#28a745' }}>98%</div>
              <div style={{ fontSize: '0.85rem', color: '#6c757d' }}>Satisfaction</div>
            </div>
          </div>

          <Link to={'/services'} className='btn btn-primary mt-10 initiate-scripts'>
            Learn More
          </Link>
        </div>
      </div>
    );
    return (
      <section className={this.props.design === 'home_1' ? 'section cm-about-us pt-80' : 'section cm-about-us'}>
        <div className='container'>
          <div className='row justify-content-center align-items-center'>
            {this.props.design === 'home_1' ? (
              <>
                {imagePart}
                {descPart}
              </>
            ) : (
              <>
                {descPart}
                {imagePart}
              </>
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default AboutArea;
